<template>
  <div>
    <h3>امنح</h3>
    <hr />

    <h5 class="text-h5 font-weight-semibold">
      ادخل موارد منظمتك التي يمكن ان تقدم من خلالها دعم لبقية المنظمات غير
      الحكومية لتتمكن من التشبيك معك.
    </h5>
    <data-table
      ep="v2/all-assists?demanded=true"
      id="give"
      :fields="fields"
      class="my-1"
    >
      <template #cell(assist.ngo)="{ value }">
        <a :href="`/ngo/${value.id}`" target="_blank">{{ value.name_ar }}</a>
      </template>
    </data-table>
  </div>
</template>

<script>
import DataTable from "@/components/data-table";
import FormInput from "@/components/form-input";
import FormSelect from "@/components/form-select";
import { BRow, BCol, BButton } from "bootstrap-vue";

export default {
  components: {
    DataTable,
    FormInput,
    FormSelect,
    BRow,
    BCol,
    BButton,
  },
  data() {
    return {
      fields: [
        { key: "assistCategory.name", label: "التصنيف" },
        { key: "assist.ngo", label: "اسم المنظمة" },
        { key: "governorate.name_ar", label: "المحافظة" },
        { key: "title", label: "الاحتياج" },
        { key: "description", label: "الوصف" },
        { key: "count", label: "العدد" },
      ],
    };
  },
};
</script>
